import '@solvapay/web-shared/src/assets/fonts.css'
import '@solvapay/web-shared/src/styles/globals.css'
import '@solvapay/web-shared/src/index.css'
import { createApp } from '@solvapay/web-shared/src/app/App'
import OperationLayout from 'layout/OperationLayout'

export default createApp({ OperationLayout })
